import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-full-screen-image',
  templateUrl: './full-screen-image.component.html',
  styleUrls: ['./full-screen-image.component.scss'],
})
export class FullScreenImageComponent {
  @ViewChild('image', { static: false }) image!: ElementRef;
  @ViewChild('zoomContainer', { static: false }) zoomContainer!: ElementRef;

  @Input() imageSrc: string = '';
  @Input() isOpen: boolean = false;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  scale: number = 1;
  lastScale: number = 1;
  maxScale: number = 3; // Fattore massimo di zoom
  minScale: number = 1; // Zoom minimo

  originalPos = { x: 0, y: 0 };
  pos = { x: 0, y: 0 };
  lastPos = { x: 0, y: 0 };

  closeViewer(): void {
    this.close.emit();
  }

  canShare() {
    return navigator.canShare();
  }

  async sharePhoto() {
    try {
      // Carica l'immagine come blob
      const response = await fetch(this.imageSrc); // Cambia con il percorso corretto

      const blob = await response.blob();

      let file;
      if (blob.type) {
        file = new File([blob], 'image', { type: blob.type });
      } else {
        file = new File([blob], 'image.jpg', { type: 'image/jpeg' });
      }
      // Crea un file basato sul blob

      // Verifica se la condivisione di file è supportata
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
        });
      } else {
      }
    } catch (error) {
      console.error('❌ Errore nella condivisione:', error);
    }
  }

  onPinch(event: any) {
    // Calcola la nuova scala, assicurandosi che rimanga nei limiti
    this.scale = Math.max(
      this.minScale,
      Math.min(this.lastScale * event.scale, this.maxScale)
    );

    // 🔹 Calcola il fattore di riduzione della traslazione basato sulla scala
    const scaleFactor = (this.scale - 1) / (this.maxScale - 1); // Va da 0 a 1

    // 🔹 Riduce progressivamente la traslazione quando si fa zoom out
    this.pos = {
      x: this.originalPos.x * scaleFactor,
      y: this.originalPos.y * scaleFactor,
    };

    this.updateTransform();
  }

  onPinchEnd() {
    this.lastScale = this.scale;
  }

  // Metodo per il pan (drag) dell'immagine quando è ingrandita
  onPan(event: any) {
    if (this.scale > 1) {
      this.pos = {
        x: this.lastPos.x + event.deltaX,
        y: this.lastPos.y + event.deltaY,
      };

      this.updateTransform();
    }
  }

  onPanEnd() {
    this.lastPos = {
      x: this.pos.x,
      y: this.pos.y,
    };
  }

  onDoubleTap() {
    if (this.scale == 1) {
      this.scale = 2;
      this.lastScale = 2;
    } else {
      this.scale = 1;
      this.lastScale = 1;
      this.pos = { x: 0, y: 0 };
      this.lastPos = { x: 0, y: 0 };
    }
    this.updateTransform();
  }

  updateTransform() {
    const imageElement = this.image.nativeElement;
    imageElement.style.transform = `translate(${this.pos.x}px, ${this.pos.y}px) scale(${this.scale})`;
  }
}
